// login modal
const loginBtn = document.querySelector("[data-login-modal]");
const loginModal = document.querySelector(".loginModal");
const loginModalClose = document.querySelector(".loginModal__close");

document.addEventListener("DOMContentLoaded", function () {
  loginBtn.addEventListener("click", function () {
    loginModal.classList.add("is-active");
  });

  loginModalClose.addEventListener("click", function () {
    loginModal.classList.remove("is-active");
  });

  loginModal.addEventListener("click", (event) => {
    if (event.target.closest(".loginModal__wrapper") === null) {
      loginModal.classList.remove("is-active");
    }
  });
});
